module.exports = __webpack_public_path__ + "img/logo_invasoras_ec.9b0310b0.png";